import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { automaticService } from "services";
import { logout } from "../logout";

export const getDeviceWorkOrderStatistics = createAsyncThunk(
  "getDeviceWorkOrderStatistics",
  async ({ workOrderId }, { rejectWithValue }) => {
    try {
      return await automaticService.getDeviceWorkOrderStatistics(workOrderId);
    } catch (error) {
      if (error.message) {
        if (error?.response?.status === 401) {
          logout();
        }
        //No response to request (No service)
        console.log("Internet Disconnected");
      } else {
        console.log(error);
        return rejectWithValue(error);
      }
    }
  }
);
export const getDeviceWorkOrderAnalytics = createAsyncThunk(
  "getDeviceWorkOrderAnalytics",
  async ({ workOrderId, skip, limit }, { rejectWithValue }) => {
    try {
      return await automaticService.getDeviceWorkOrderAnalytics(workOrderId, skip, limit);
    } catch (error) {
      if (error.message) {
        if (error?.response?.status === 401) {
          logout();
        }
        //No response to request (No service)
        console.log("Internet Disconnected");
      } else {
        console.log(error);
        return rejectWithValue(error);
      }
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  currentDeviceWorkOrder: null,
  currentDeviceWorkOrderStatistics: null,
  currentDeviceWorkOrderAnalytics: null
};

const deviceWorkOrderSlice = createSlice({
  name: "deviceWorkOrder",
  initialState: initialState,
  reducers: {
    setCurrentDeviceWorkOrder: (state, action) => {
      state.currentDeviceWorkOrder = action.payload;
    },
    clearDeviceWorkOrder: (state, _action) => {
      state.currentDeviceWorkOrder = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDeviceWorkOrderStatistics.pending, (state, _action) => {
      state.loading = true;
    });
    builder.addCase(getDeviceWorkOrderStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.currentDeviceWorkOrderStatistics = action.payload;
      state.error = null;
    });
    builder.addCase(getDeviceWorkOrderStatistics.rejected, (state, action) => {
      state.loading = false;
      state.currentDeviceWorkOrderStatistics = null;
      state.error = action.payload;
    });
    builder.addCase(getDeviceWorkOrderAnalytics.pending, (state, _action) => {
      state.loading = true;
    });
    builder.addCase(getDeviceWorkOrderAnalytics.fulfilled, (state, action) => {
      state.loading = false;
      state.currentDeviceWorkOrderAnalytics = action.payload;
      state.error = null;
    });
    builder.addCase(getDeviceWorkOrderAnalytics.rejected, (state, action) => {
      state.loading = false;
      state.currentDeviceWorkOrderAnalytics = null;
      state.error = action.payload;
    });
  },
});

export const { clearDeviceWorkOrder, setCurrentDeviceWorkOrder } = deviceWorkOrderSlice.actions;
export default deviceWorkOrderSlice.reducer;
